const state = {
  products: [],
  pageNum: 1,
  hasMore: true,
  locale: '',
};

const mutations = {
  SET_PRODUCT_LIST_CACHE(state, payload = {}) {
    state.products = Array.isArray(payload.products) ? payload.products : [];
    state.pageNum = Number(payload.pageNum) > 0 ? Number(payload.pageNum) : 1;
    state.hasMore = Boolean(payload.hasMore);
    state.locale = String(payload.locale || '');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
